import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { FieldAgentClient, GroupAccountDisplayType } from 'ep-bt-field-agent-proxy';
import { EpGridComponent, IEpGridModel, IEpGridState, IEPGridDataResult, EpGridEvent, IEpGridSelectionOptions, IEpPanelbarModel } from '@epicor/kinetic';
import { Observable } from 'rxjs';
import { IEpBtCardControlModel, BistrackConfig } from 'ep-bt-controls';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-customer-financial-details',
  templateUrl: './epbt-fa-customer-financial-details.component.html',
  styleUrls: ['./epbt-fa-customer-financial-details.component.scss']
})
export class EpbtFaCustomerFinancialDetailsComponent implements OnInit {

  private _customerId;
  @Input() webTrackInstanceID: number;
  @Input() customerId: number;

  data: any;

  @ViewChild(EpGridComponent, {static: false}) grid: EpGridComponent;
  @ViewChild('percentageTemplate', {static: true}) percentageTemplate: TemplateRef<any>;
  @ViewChild('decimalTemplate', {static: true}) decimalTemplate: TemplateRef<any>;

  showGrid = true;
  public gridModel: IEpGridModel;
  public pageSize = 15;
  public cards: Array<IEpBtCardControlModel>;

  cardModels: IEpGridModel[] = [];
  cardModel: IEpGridModel;
  webTrackUser: any;
  groupAccountType: any;

  constructor(private config: BistrackConfig, private client: FieldAgentClient, private fieldAgentService: EpbtFieldAgentService) { }

  ngOnInit() {
    this.webTrackInstanceID = this.config.getwebTrackInstanceID();

    this._customerId = this.customerId;
    // this.webTrackUser = this.fieldAgentService.getWebTrackUser();
    // this.groupAccountType=this.webTrackUser.customer.groupAccountDisplay;

    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      this.groupAccountType = this.webTrackUser.customer.groupAccountDisplay;
    });

    this.gridModel = this.getGridModel();
    this.getGridData();

    // this._customerId=this.customerId;
    // this.fieldAgentService.getWebTrackUser().subscribe(webTrackRes => {
    //       this.webTrackUser = webTrackRes;
    //       this.groupAccountType=this.webTrackUser.customer.groupAccountDisplay;
    //      // console.log(this.webTrackUser, 'finance details id');
    //       this.gridModel = this.getGridModel();
    //        this.getGridData();
    // });

  }


  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'customerId',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: false,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: true,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      data: this.data,
      columns: [
        { field: 'userData.timerangelabel', title: 'ORDER TYPE', width: 30, hidden: false },
        { field: 'userData.numberOfTransactions', title: 'NO.OF TRANSACTIONS', width: 30, hidden: false },
        { field: 'userData.balance', title: 'VALUE OF TRANSACTIONS', width: 30, hidden: false, cellTemplate: this.decimalTemplate },
        { field: 'userData.percentOfTransactions', title: 'PERCENTAGE OF TRANSACTIONS', width: 30, hidden: false, cellTemplate: this.percentageTemplate }
      ]
    };
    return model;
  }

  getGridData() {

    this.cardModels = [];

    const labelNames = ['Current', '1-30', '31-60', '61-90', '91 - 120', '121-150', '151+'];
    this.client.getCustomerFinancialDetails(this.webTrackInstanceID, this._customerId, this.groupAccountType).subscribe(res => {
      this.data = res;
      let i = 0;
      res.agingTable.forEach(response => {

        const cardModel: any = {
          userData: {
            timerangelabel: labelNames[i++],
            numberOfTransactions: response.numberOfTransactions,
            balance: response.balance,
            percentOfTransactions: response.percentOfTransactions
          }
        };
        this.cardModels.push(cardModel);
      });
      // console.log(this.cardModels);
      // console.log(JSON.stringify(this.cardModels));
      this.gridModel.data = this.cardModels;

    });

  }

  getHeight(): number {
    const height = parseInt($('body').height());

    if (height > 900) {
      // return 300;
      return 700;
    } else {
      return 370; // return 500;
    }
  }


}

